export default __webpack_public_path__ + "static/media/bg_bottom_mobile_new.284e7967.jpg";